import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// 创建应用实例
const app = createApp(App)

// 添加调试信息
app.config.errorHandler = (err) => {
  console.error('Vue Error:', err)
}

router.beforeResolve((to, from, next) => {
  console.log('Route resolving:', {
    from: from.path,
    to: to.path
  })
  next()
})

// 使用路由
app.use(router)

// 挂载应用
app.mount('#app')

// 确认路由已经安装
console.log('Router installed:', router.currentRoute.value) 